import type { RecoveryEquipment } from "../types/garage";

const NOW = "2026-07-31T10:15:00.000Z";

export const recoveryEquipment: RecoveryEquipment[] = [
  {
    id: "recovery-cold-plunge",
    category: "recovery",
    lifecycleStatus: "active",
    readinessStatus: "ready",
    archived: false,
    notes: "Default daily protocol is a fast wake-up plunge before coffee.",
    createdAtIso: NOW,
    updatedAtIso: NOW,
    name: "Cold Plunge",
    type: "cold-plunge",
    preferredTiming: "immediately-after-waking",
    defaultTemperatureF: 44,
    defaultDurationMinutes: 4,
    contrastTherapyProtocols: [
      {
        id: "contrast-evening-1",
        enabled: false,
        rounds: 3,
        coldDurationMinutes: 2,
        hotDurationMinutes: 8,
        notes: "Optional contrast protocol; disabled by default."
      }
    ]
  },
  {
    id: "recovery-hot-tub",
    category: "recovery",
    lifecycleStatus: "active",
    readinessStatus: "ready",
    archived: false,
    notes: "Evening downregulation after hard sessions.",
    createdAtIso: NOW,
    updatedAtIso: NOW,
    name: "Hot Tub",
    type: "hot-tub",
    preferredTiming: "evening",
    defaultTemperatureF: 102,
    defaultDurationMinutes: 12,
    contrastTherapyProtocols: []
  },
  {
    id: "recovery-sauna",
    category: "recovery",
    lifecycleStatus: "planned",
    readinessStatus: "planned",
    archived: false,
    notes: "Planned future addition for heat adaptation block.",
    createdAtIso: NOW,
    updatedAtIso: NOW,
    name: "Sauna",
    type: "sauna",
    preferredTiming: null,
    defaultTemperatureF: null,
    defaultDurationMinutes: null,
    contrastTherapyProtocols: []
  },
  {
    id: "recovery-massage-gun",
    category: "recovery",
    lifecycleStatus: "inactive",
    readinessStatus: "unavailable",
    archived: false,
    notes: "Recharge battery before use.",
    createdAtIso: NOW,
    updatedAtIso: NOW,
    name: "Massage Gun",
    type: "massage-gun",
    preferredTiming: "evening",
    defaultTemperatureF: null,
    defaultDurationMinutes: 10,
    contrastTherapyProtocols: []
  }
];
